import { Link } from 'react-router-dom';
import { Play, Film } from 'lucide-react';

const categoryColors = {
  cartoon: { bg: '#FF3860', text: 'white' },
  live_action: { bg: '#4AC6FF', text: '#0A0A0A' },
  commercial: { bg: '#FFDE00', text: '#0A0A0A' },
};

const categoryLabels = {
  cartoon: 'Cartoon',
  live_action: 'Live Action',
  commercial: 'Commercial',
};

const eraLabels = {
  early_90s: 'Early 90s',
  late_90s: 'Late 90s',
  early_2000s: 'Early 2000s',
};

const placeholderImage = 'data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 400 225%22><rect width=%22400%22 height=%22225%22 fill=%22%23FDFBEC%22/><text x=%22200%22 y=%22118%22 font-family=%22sans-serif%22 font-size=%2218%22 fill=%22%234B5563%22 text-anchor=%22middle%22>Retro Playground TV</text></svg>';

export default function ShowCard({ show, index = 0 }) {
  const cat = categoryColors[show.category] || categoryColors.cartoon;
  const bgColors = ['#FDFBEC', '#E8F4FD', '#FFF0F3', '#F0FFF0', '#FFF8E1'];
  const cardBg = bgColors[index % bgColors.length];

  return (
    <Link
      to={`/show/${show.id}`}
      className="neo-card block overflow-hidden group"
      style={{ backgroundColor: cardBg }}
      data-testid={`show-card-${show.id}`}
    >
      <div className="relative aspect-video overflow-hidden border-b-2 border-[#0A0A0A]">
        <img
          src={show.thumbnail_url || placeholderImage}
          alt={show.title}
          className="w-full h-full object-cover vhs-thumbnail group-hover:scale-105 transition-transform duration-300"
          onError={(e) => { e.target.src = placeholderImage; }}
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
          <div className="opacity-0 group-hover:opacity-100 transition-opacity">
            <div className="w-12 h-12 rounded-full bg-white/90 border-2 border-[#0A0A0A] flex items-center justify-center shadow-[2px_2px_0px_0px_rgba(10,10,10,1)]">
              <Play size={20} fill="#FF3860" className="text-[#FF3860] ml-0.5" />
            </div>
          </div>
        </div>
        {/* Category badge */}
        <span
          className="absolute top-2 left-2 px-2 py-0.5 text-xs font-bold rounded-md border-2 border-[#0A0A0A] shadow-[2px_2px_0px_0px_rgba(10,10,10,1)]"
          style={{ backgroundColor: cat.bg, color: cat.text }}
        >
          {categoryLabels[show.category] || show.category}
        </span>
      </div>
      <div className="p-4">
        <h3 className="font-['Fredoka'] font-bold text-lg text-[#0A0A0A] mb-1 line-clamp-1">{show.title}</h3>
        <p className="text-sm text-[#4B5563] font-['Nunito'] line-clamp-2 mb-3">{show.description}</p>
        <div className="flex items-center justify-between">
          <span className="text-xs font-bold px-2 py-0.5 rounded bg-[#F4F4F5] border border-[#0A0A0A]/20 font-['IBM_Plex_Mono']">
            {eraLabels[show.era] || show.era}
          </span>
          {show.episode_count != null && (
            <span className="flex items-center gap-1 text-xs text-[#4B5563] font-bold">
              <Film size={12} strokeWidth={2.5} /> {show.episode_count} ep{show.episode_count !== 1 ? 's' : ''}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
